import Action from '../Action'
import './styles/ModalCisAfecta.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import Search from '../generales/Search';
import SelectorAdmin from '../SelectorAdmin'
import { lang } from '../generales/traduction';
import { capitalizeFirstLetter } from '../../utils/utils';
const ModalCisAfecta =({server,cisSelected,closeCisAfectaModal,languaje,mode})=>{
    
    const [dataCisRel,setDataCisRel]=useState({data:[],loading:true,error:null})
    const [dataCis,setDataCis]=useState({data:[],loading:true,error:null})
    const [cisRelation,setCisRelation]=useState(0)
    const [relationResponse,setRelationResponse]=useState([])
    const [responseDetail,setResponseDetail]=useState({text:'',value:true})
    useEffect(()=>{
        buscar_cis_relations()
        buscar_cis()
      },[])
    const buscar_cis_relations=()=>{
        
        
        // setLoadingCis(true)
        setDataCisRel({data:dataCisRel.data,loading:true,error:dataCisRel.error})
          const fetchDataPost = async () => {
            
         try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/relations/'+cisSelected.element_id, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           if (response.ok) {
             const data1 = await response.json();
             setDataCisRel({data:data1.data,loading:false,error:dataCisRel.error})
             // setCreateCisModalOpen(true)
           } else {
             const data1 = await response.json();
             throw new Error('Error en la solicitud');
           }
         } catch (error) {
              console.error(error);
            }
          };
      
          fetchDataPost();
        
    }
    const buscar_cis=()=>{
        
        
        setDataCis({data:dataCis.data,loading:true,error:null})
          const fetchDataPost = async () => {
            
         try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/', {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           if (response.ok) {
             const data1 = await response.json();
             setDataCis({data:data1.data,loading:false,error:null})
             // setCreateCisModalOpen(true)
           } else {
             const data1 = await response.json();
             throw new Error('Error en la solicitud');
           }
         } catch (error) {
              console.error(error);
            }
          };
      
          fetchDataPost();
        
    }
    const handledeleteRelationClick=(elemento)=>{
      const fetchDataPost = async () => {
        try {
          const response = await fetch(server.url+'/api/v1/cassia/ci_elements/relations/'+elemento.cassia_ci_relation_id, {
         
            method: 'DELETE',  
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
          });
          if (response.ok) {
            const data1 = await response.json();

            setResponseDetail({text:data1.message,value:true})
            const timer = setTimeout(() => {
                setResponseDetail({text:'',value:true})
              }, 2000);
            buscar_cis_relations()
          } else {
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
             
             console.error(error);
           }
      };

      fetchDataPost();
    }
    const changeOption=(option,index)=>{
      setCisRelation(option.value)
    }

    const addRelation=async(e)=>{
      const formData = new URLSearchParams();
      formData.append("affected_ci_element_id", cisRelation);


      try {
        const response = await fetch(server.url+'/api/v1/cassia/ci_elements/relations/'+cisSelected.element_id, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: formData
        });
        if (response.ok) {
          
          const data = await response.json();
          setRelationResponse(data)
          setResponseDetail({text:'',value:true})
          const timer = setTimeout(() => {
              setResponseDetail({text:'',value:true})
            }, 2000);
          buscar_cis_relations()
        } else {
          const data = await response.json();
          setResponseDetail({text:data.detail,value:false})
          throw new Error('Error en la solicitud');
        }
      } catch (error) {}
    }
   return(
       <>
       <div className="modal-user-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs' style={{display:'flex',justifyContent:'space-around'}}>
                       <p>CI´s {capitalizeFirstLetter(lang[languaje]['afectadoPor'])}: &nbsp;</p><p>  {'   '+cisSelected.folio}</p>
                    </div>
                </div>
                <div className='content-card-modal-gs' >
                <div className='body_info_cis_relation'>
        <div className='content-cis_relation' style={{border: 'px solid #607582',boxShadow:'unset'}}>
                {/* <div className='cont-cis-search' style={{background:'transparent '}}>
              
              <>
                <div className='cont-search-relation hiddenPDF'>
                    <Search  dataUsers={[]}  />
                </div>
                <div className='cont-search-space'>

                </div>
                <div className='cont-search-buttons hiddenPDF'>
                </div>
              </>
                </div> */}
                <div className='cont-cis-search' style={{background:'transparent '}}>
              
              <>
                <div className='cont-search-relation hiddenPDF'>
                    
                <SelectorAdmin opGeneral={false} txtOpGen={'TODOS'}  opt_de={'0'}origen={'Admin'} data={dataCis.data} loading={dataCis.loading}  titulo='CIS' selectFunction={changeOption} index={0}></SelectorAdmin>
                </div>
                <div className='cont-search-space'>
                        <div className='msgErrorRelation' style={{color:(responseDetail.value)?'gree':'red'}}>
                            {responseDetail.text}
                        </div>
                </div>
                <div className='cont-search-buttons hiddenPDF'>
                <Action disabled={false} origen='Azul' titulo={'+  '+capitalizeFirstLetter(lang[languaje]['agregar'])} action={addRelation}  />
                </div>
              </>
                </div>
                <div className='cont-cis-table-relation'>
                    <div className='content-card-cis-relation ' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                    
                    {
                        (dataCisRel.loading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}><LoadSimple></LoadSimple></div>:
                        
                        dataCisRel.data.map((elemento, indice) => (
                        <div className='cont-elemen-relation-gs' >
                            <div className='elemen-relation-gs'>
                               <div className='con-elemen-relation-info-gs'>
                                {elemento.folio}
                                </div>
                                <div className='con-elemen-relation-img-gs'>
                                    <div className='cont-img-field-acciones-gs' >
                                        <img className='img-field-acciones-gs img-relation' src='/iconos/delete.png' title='Eliminar'name='Eliminar' ci_id={elemento.ci_id} onClick={(e)=> {e.stopPropagation(); handledeleteRelationClick(elemento)}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        ))

                    }
                                    
                    </div>
                </div>
            </div>
        </div>
                                   
                </div>
                </div>
        </div>
       </>
    )
}

export default ModalCisAfecta